import React, { useEffect, useRef } from 'react';
import CBPopover from '@cb/apricot/CBPopover';
import { CloseButton } from '@cb/apricot-react-button';
import { useUID } from 'react-uid';
import cn from 'classnames';
export const popoverPlacements = ['top', 'right', 'bottom', 'left'];
export const Popover = ({ trigger, shadowRoot = false, popoverId, headerId, popoverTitle, children, triggerEvent = 'click', placement = 'top', closeButton, closeButtonLabel = 'Close Popover', closeOnClickOutside = true, className, popoverClassName, onShow = null, onHide = null, cbRef, }) => {
    const popoverRef = useRef(null);
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    headerId = headerId || `apricot_popover_header_${uid}`;
    useEffect(() => {
        const popover = CBPopover({
            elem: typeof trigger === 'string' ? document.getElementById(trigger) : trigger,
            trigger: triggerEvent,
            popoverNode: popoverRef.current,
            placement,
            shadowRoot,
            closeOnClickOutside,
            style: popoverClassName,
            onShow,
            onHide,
        });
        if (cbRef) {
            // eslint-disable-next-line no-param-reassign
            cbRef.current = popover;
        }
        return () => {
            if (popover) {
                popover.destroy();
            }
        };
    }, []);
    return (React.createElement("div", { id: popoverId, className: cn('cb-popover', className), "aria-hidden": "true", role: "region", "data-cbtrack-comp": "apricot-react:popover", ref: popoverRef },
        React.createElement("div", { className: "cb-popover-inner" },
            popoverTitle && (React.createElement("div", { className: cn('cb-popover-header', closeButton && 'cb-popover-close') },
                React.createElement("h3", { id: headerId, className: "cb-popover-title" }, popoverTitle),
                closeButton && (React.createElement(CloseButton, { "aria-describedby": headerId, label: closeButtonLabel, "data-cb-popover-close": true })))),
            React.createElement("div", { className: "cb-popover-content" }, children))));
};
//# sourceMappingURL=Popover.js.map